import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCLrsGIa7Dr_r9YKwjnjxRwu9S42StHsM4',
  authDomain: 'orgtomi.firebaseapp.com',
  databaseURL: 'https://orgtomi-default-rtdb.firebaseio.com',
  projectId: 'orgtomi',
  storageBucket: 'orgtomi.appspot.com',
  messagingSenderId: '706347978299',
  appId: '1:706347978299:web:c5e215989aaf1d559f961e',
  measurementId: 'G-Q08DCVS0XB'
};

const firebaseApp = initializeApp(firebaseConfig);

let analyticsInstance;

if (typeof window !== 'undefined') {
  isAnalyticsSupported()
    .then((supported) => {
      if (supported) {
        analyticsInstance = getAnalytics(firebaseApp);
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.warn('[Firebase] Analytics no disponible:', error);
    });
}

export { firebaseApp, analyticsInstance as analytics };

